// src/components/VideoControls.jsx
import React from "react";

const VideoControls = ({
  streamUrl,
  setStreamUrl,
  confidence,
  setConfidence,
  riskThreshold,
  setRiskThreshold,
  onTest,
  onStart,
  onStop,
  isDetecting,
  loading,
}) => {
  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "14px",
    background: "white",
    transition: "border-color 0.2s",
  };

  const buttonStyle = (variant = "default") => {
    const styles = {
      default: {
        background: "white",
        color: "#666",
        border: "1px solid #ddd",
      },
      primary: {
        background: "#4a90e2",
        color: "white",
        border: "none",
      },
      danger: {
        background: "#dc3545",
        color: "white",
        border: "none",
      },
    };

    return {
      padding: "10px 20px",
      borderRadius: "4px",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      transition: "all 0.2s",
      ...styles[variant],
    };
  };

  return (
    <div
      style={{
        background: "white",
        borderRadius: "8px",
        padding: "25px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        border: "1px solid #e9ecef",
      }}
    >
      <h3
        style={{
          color: "#2c3e50",
          marginBottom: "20px",
          fontSize: "1.3rem",
          fontWeight: "500",
        }}
      >
        🎛️ Detection Controls
      </h3>

      <div style={{ marginBottom: "20px" }}>
        <label
          style={{
            display: "block",
            marginBottom: "6px",
            fontWeight: "500",
            color: "#555",
            fontSize: "0.95rem",
          }}
        >
          Video Source:
        </label>
        <input
          type="text"
          value={streamUrl}
          onChange={(e) => setStreamUrl(e.target.value)}
          placeholder="Enter URL or '0' for webcam"
          style={inputStyle}
        />
      </div>

      {/* <div style={{ marginBottom: "20px" }}>
        <label
          style={{
            display: "block",
            marginBottom: "6px",
            fontWeight: "500",
            color: "#555",
            fontSize: "0.95rem",
          }}
        >
          Confidence Threshold: {confidence}
        </label>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <input
            type="range"
            min="0.1"
            max="1.0"
            step="0.1"
            value={confidence}
            onChange={(e) => setConfidence(parseFloat(e.target.value))}
            style={{
              flex: 1,
              height: "4px",
              borderRadius: "2px",
              background: "#ddd",
              appearance: "none",
              outline: "none",
            }}
          />
          <span
            style={{
              minWidth: "40px",
              textAlign: "center",
              fontWeight: "500",
              color: "#666",
            }}
          >
            {confidence}
          </span>
        </div>
      </div> */}

      <div style={{ marginBottom: "25px" }}>
        <label
          style={{
            display: "block",
            marginBottom: "6px",
            fontWeight: "500",
            color: "#555",
            fontSize: "0.95rem",
          }}
        >
          High Risk Threshold: {riskThreshold}
        </label>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <input
            type="range"
            min="0.5"
            max="1.0"
            step="0.1"
            value={riskThreshold}
            onChange={(e) => setRiskThreshold(parseFloat(e.target.value))}
            style={{
              flex: 1,
              height: "4px",
              borderRadius: "2px",
              background: "#ddd",
              appearance: "none",
              outline: "none",
            }}
          />
          <span
            style={{
              minWidth: "40px",
              textAlign: "center",
              fontWeight: "500",
              color: "#666",
            }}
          >
            {riskThreshold}
          </span>
        </div>
      </div>

      <div
        style={{
          textAlign: "center",
          display: "flex",
          flexWrap: "wrap",
          gap: "8px",
          justifyContent: "center",
        }}
      >
        <button
          onClick={onStart}
          disabled={loading || isDetecting}
          style={buttonStyle("primary")}
        >
          {loading ? (
            <>
              <span
                className="loading-spinner"
                style={{ marginRight: "6px" }}
              ></span>
              Starting...
            </>
          ) : (
            "🎬 Start Detection"
          )}
        </button>
        <button
          onClick={onStop}
          disabled={!isDetecting}
          style={buttonStyle("danger")}
        >
          ⏹️ Stop
        </button>
      </div>
    </div>
  );
};

export default VideoControls;
